<div class="modal-body p-0 width-100 flex">
    <div class="img-modal" ></div>
    <div class="p-4 width-100 flex">
        <p><strong>{{mensagem}}</strong></p>
        <app-botao-vermelho title="Ok" (click)="close()"></app-botao-vermelho>
    </div>
</div>
